export function sumOfArrayByProperty(array: object[], property: string) {
    return array.reduce((a, b) => a + b[property], 0);
};